import react, { useEffect, useState } from "react";
import cancel from '../assets/cancel.png'
import { toast } from "react-toastify";
import axios from "axios";
import serverURL from "../config";

const CategoryModal = ({ title, category, closeCategoryModal, fetchCategory }) => {

    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setFormData({
            category_name: category?.category_name || '',
            description: category?.description || '',
            is_active: !!category?.is_active,
        });
    }, [category]);


    const handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };
    

    const handleClose = () => {
        setFormData({});
        closeCategoryModal();
    }

    console.log(category);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (title !== "Delete Event") {
            if (!formData.category_name || !formData.description || !formData.is_active) {
                toast.error('Please fill in all required fields.');
                setLoading(false);
                return;
            }
        }

        const token = localStorage.getItem('token');
        try {
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };

            let response;
            if (title === "Add Category") {
                response = await axios.post(`${serverURL}/categories`, formData, { headers });
                toast.success('Category created successfully!');
            } else if (title === "Edit Category") {
                response = await axios.put(`${serverURL}/categories/${category.id}`, formData, { headers });
                toast.success('Category edited successfully!');
            } else if (title === "Delete Category") {
                response = await axios.delete(`${serverURL}/categories/${category.id}`, { headers });
                toast.success('Category deleted successfully!');
            }
            if (fetchCategory) {
                fetchCategory();
            }
            handleClose();
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'An unexpected error occurred.';
            toast.error(errorMessage);
            console.error('Error details:', error.response || error.message);
        }
        setLoading(false);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-6 rounded shadow-lg relative w-1/3 overflow-y-auto" style={{ maxHeight: "80vh" }}>
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-bold text-red-500">{title}</h3>
                    <button
                        onClick={handleClose}
                        className="text-white rounded"
                    >
                        <img src={cancel} width={"25px"} alt="Close" />
                    </button>
                </div>
                {title === 'Delete Category' ? (
                    <div className="flex flex-col items-center justify-center py-3 gap-4">
                        <h3 className="text-xl text-black">
                            Are you sure to delete this event?
                        </h3>
                        <button onClick={handleSubmit} className="bg-red-500 px-5 py-2 text-white rounded">
                            Yes
                        </button>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Category Title
                            </label>
                            <input
                                type="text"
                                name="category_name"
                                placeholder="Enter Category title"
                                value={formData.category_name || ''}
                                onChange={handleChange}
                                className={`w-full p-2 border rounded ${!formData.category_name && 'border-red-500'}`}
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Category Description
                            </label>
                            <input
                                type="text"
                                name="description"
                                placeholder="Enter Category Description"
                                value={formData.description || ''}
                                onChange={handleChange}
                                className={`w-full p-2 border rounded ${!formData.description && 'border-red-500'}`}
                            />
                        </div>
                        <div className="mb-4 flex items-center">
                            <label class="text-gray-700 text-sm font-bold mr-2">Active</label>
                            <input type="checkbox" name="is_active" checked={formData.is_active} onChange={handleChange} className="w-5 h-5 text-blue-600"/>
                        </div>
                        <div className="flex justify-end">
                            <button
                                type="submit"
                                className="bg-red-500 text-white px-4 py-2 rounded"
                            >
                                Save
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};
export default CategoryModal;